module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/238.2cc25412.png";